// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"04fe6a4c","453":"419a5d54","985":"9aba7be5"}[chunkId] + ".chunk.js";
};